import React from "react";
import { Box, Typography } from "@mui/material";
import { formatDate, formatMoney, formatPercent, formatYesNo } from "../gestionCarteraFormat";
import { COLORS, labelSx, ModalShell, SecondaryButton } from "../gestionCarteraUi";

const moneyOrDash = (value) => (value === null || value === undefined ? "—" : formatMoney(value));

/** Campos de CreditDto (GET /v1/credits/{uuid}) agrupados por sección. */
const buildSections = (credit) => [
  {
    title: "Fechas",
    items: [
      { label: "Fecha de originación", value: formatDate(credit.originDate) },
      { label: "Fecha de desembolso", value: formatDate(credit.fechaDesembolso) },
      { label: "Inicio de pagos", value: formatDate(credit.paymentStartDate) },
      { label: "Fecha de finalización", value: formatDate(credit.endDate) },
    ],
  },
  {
    title: "Tasas y comisiones",
    items: [
      { label: "Tasa de interés (Mes vencido)", value: formatPercent(credit.interestRate) },
      { label: "Comisión del comercio", value: formatPercent(credit.commissionPercentage, { isFraction: false }) },
      { label: "IVA de la comisión", value: moneyOrDash(credit.ivaCommission) },
    ],
  },
  {
    title: "Garantía",
    items: [
      { label: "Fondo de garantía", value: credit.fondoGarantia || "—" },
      { label: "Tarifa FGA", value: formatPercent(credit.tarifaFga) },
      { label: "Cuotas con FGA", value: credit.fgaInstallmentsCount ?? "—" },
    ],
  },
  {
    title: "Estado y operación",
    items: [
      { label: "Reestructurado", value: formatYesNo(credit.reestructurado) },
      { label: "Crédito ampliado", value: formatYesNo(credit.isExtendedCredit) },
      { label: "Monto de ampliación", value: moneyOrDash(credit.extensionAmount) },
      { label: "Pagado al comercio", value: formatYesNo(credit.paidToCommerce) },
      { label: "Fecha de pago al comercio", value: formatDate(credit.paidToCommerceDate) },
      { label: "Documentos completos", value: formatYesNo(credit.documentosCompletos) },
      { label: "Facturado", value: formatYesNo(credit.estaFacturado) },
    ],
  },
];

/** Más información del crédito (solo lectura), abierto desde el ícono (i) de "Condiciones del crédito". */
export default function MasInfoCreditoModal({ open, credit, title, onClose }) {
  if (!credit) return null;
  return (
    <ModalShell
      open={open}
      onClose={onClose}
      title="Más información del crédito"
      subtitle={title}
      maxWidth="md"
      actions={<SecondaryButton onClick={onClose}>Cerrar</SecondaryButton>}
    >
      {buildSections(credit).map((section) => (
        <Box component="section" key={section.title} aria-label={section.title}>
          <Typography
            component="h3"
            sx={{ fontSize: 14, fontWeight: 700, color: COLORS.muted, mb: 1.5 }}
          >
            {section.title}
          </Typography>
          <Box component="dl" sx={{ m: 0, display: "grid", gridTemplateColumns: { xs: "1fr 1fr", md: "repeat(4, 1fr)" }, gap: 2 }}>
            {section.items.map((item) => (
              <Box key={item.label}>
                <Typography component="dt" sx={labelSx}>{item.label}</Typography>
                <Typography component="dd" sx={{ m: "2px 0 0", fontWeight: 500 }}>{item.value}</Typography>
              </Box>
            ))}
          </Box>
        </Box>
      ))}
    </ModalShell>
  );
}
